module.exports = "<qms-alert></qms-alert> <qms-faculties-grid></qms-faculties-grid> <qms-queues-grid *jhiHasAnyAuthority=\"'ROLE_STAFF'\"></qms-queues-grid> ";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/components/home/home.component.html
// module id = 223
// module chunks = 0